(() => {
  const configElement = document.getElementById('ViewInRoomConfig');
  if (!configElement || configElement.dataset.initialized) return;
  configElement.dataset.initialized = 'true';

  // Both waits are short on purpose. A variant shopper who waits out a long deadline has
  // already been counted as variant by Shoplift while seeing control, which dilutes the
  // test in the feature's disfavour. Giving up early keeps that window small.
  const SHOPLIFT_DEADLINE = 1500;

  function waitForShoplift() {
    return new Promise((resolve) => {
      const deadline = Date.now() + SHOPLIFT_DEADLINE;
      const check = () => {
        if (typeof window.shoplift?.isHypothesisActive === 'function') resolve(window.shoplift);
        else if (Date.now() >= deadline) resolve(null);
        else setTimeout(check, 100);
      };
      check();
    });
  }

  function withTimeout(promise) {
    return new Promise((resolve, reject) => {
      const timer = setTimeout(() => resolve(false), SHOPLIFT_DEADLINE);
      Promise.resolve(promise).then(resolve, reject).finally(() => clearTimeout(timer));
    });
  }

  function loadAsset(url, stylesheet) {
    return new Promise((resolve, reject) => {
      const element = document.createElement(stylesheet ? 'link' : 'script');
      if (stylesheet) {
        element.rel = 'stylesheet';
        element.href = url;
      } else {
        element.src = url;
      }
      element.onload = resolve;
      element.onerror = () => reject(new Error('asset_load_failed'));
      document.head.append(element);
    });
  }

  function decline() {
    document.documentElement.setAttribute('data-view-in-room-declined', '');
  }

  async function initialize() {
    const config = JSON.parse(configElement.textContent);
    if (config.mode === 'shoplift') {
      const hypothesisId = config.hypothesisId?.trim();
      if (!hypothesisId) return decline();
      const shoplift = await waitForShoplift();
      if (!shoplift || await withTimeout(shoplift.isHypothesisActive(hypothesisId)) !== true) return decline();
    } else if (config.mode !== 'on') return decline();

    const product = document.querySelector('view-in-room-gallery') ? config.product : null;
    await Promise.all([...config.styles, ...(product?.styles || [])].map((url) => loadAsset(url, true)));
    for (const url of [...config.scripts, ...(product?.scripts || [])]) await loadAsset(url, false);
    document.documentElement.setAttribute('data-view-in-room-active', '');
  }

  initialize().catch(() => {
    decline();
    console.warn('[View in Room] Feature could not be initialized.');
  });
})();
